import { Injectable, Type } from '@angular/core';
import { DialogRef, ModalComponent, CloseGuard } from 'ngx-modialog';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { Overlay, overlayConfigFactory } from "ngx-modialog";

import { ModelUtil } from './../model/model.uitl';
import { Modo } from '../enum/modo.enum';

@Injectable()
export class CadastroModalUtil implements CloseGuard {
    private dialog: DialogRef<BSModalContext>;

    public model: ModelUtil;

    public modo: Modo;

    public onModal: Boolean = false;

    public callBackFunction: Function;

    public modelSelect: any;

    public confirmado: boolean = false;

    constructor(public modal: Modal) {
    }

    openModal(component: Type<any>, className: string = '') {
        this.onModal = true;
        this.modal.open(component, overlayConfigFactory(
            {
            isBlocking: true,
            size: 'lg',
            dialogClass: 'modal-dialog modal-cadastro content-wrapper ' + className
            },
            BSModalContext)
        ).then((modal) => {
            this.dialog =  modal;
            this.dialog.setCloseGuard(this);
            // Correção para o dismiss
            this.dialog.onDestroy.subscribe(() => this.onModal = false);
        });
    }

    closeModal(){
        if (this.dialog == undefined || this.dialog == null) {
            return;
        }
        this.onModal = false;
        this.dialog.close(true);

        if(this.callBackFunction != undefined){
          this.callBackFunction();
        }

    }

    beforeDismiss(){
        return false;
    }

    beforeClose(){
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/util/modal/cadastro.modal.util.ts